<template>
  <div>
    <spinner size="80" :line-size="12" line-fg-color="grey" line-bg-color="lightgrey" :speed="1.5" v-if="loading">
    </spinner>
    <div v-if="!poa && !loading" class="mt-4">{{ $t('message.accountPowerOfAttorneyForm.pleaseUpload') }}</div>
    <div v-if="poa">
      <b-btn @click="onPrintPoaFn">
        <span class="ti-printer"></span>
        <span class="mx-2">|</span>
        {{ fullName }} {{ $t('message.accountPowerOfAttorneyForm.btn.printPoa') }}
      </b-btn>
    </div>
    <div v-if="poa">
      <b-btn variant="link"
             class="mt-4 text-muted font-weight-light p-0"
             v-b-modal.revoke_poa>
        {{ $t('message.accountPowerOfAttorneyForm.btn.revokePoa') }}
      </b-btn>
    </div>
    <div v-if="!poa && !loading" class="mt-4">
      <b-row class="mt-4">
        <b-col class="text-right">
          <label class="btn btn-primary mb-0">
            {{ $t('message.accountPowerOfAttorneyForm.btn.browse') }}
            <input type="file" hidden @change="uploadPoa" accept="application/pdf, image/*">
          </label>
        </b-col>
      </b-row>
    </div>

    <b-modal id="revoke_poa"
             cancel-variant="primary"
             ok-variant="danger"
             :title="$t('message.accountPowerOfAttorneyForm.title')"
             :ok-title="$t('message.accountPowerOfAttorneyForm.btn.ok')"
             :cancel-title="$t('message.accountPowerOfAttorneyForm.btn.cancel')"
             @ok="revoke">
      <p class="mt-4">{{ $t('message.accountPowerOfAttorneyForm.message') }}</p>
    </b-modal>
  </div>
</template>
<script>
  import Spinner from 'vue-simple-spinner'

  export default {
    name: 'AccountPowerOfAttorneyForm',

    destroyed () {
      this.$store.commit('setPowerOfAttorney', null)
    },
    components: {
      Spinner
    },
    computed: {
      fullName () {
        const title = this.user.title ? this.user.title : ''
        const firstName = this.user.firstName ? this.user.firstName : ''
        const lastName = this.user.lastName ? this.user.lastName : ''
        return `${title} ${firstName} ${lastName}`
      },
      poa () {
        return this.$store.getters.powerOfAttorney
      }
    },
    created () {
      if (!this.$store.getters.powerOfAttorney) {
        this.loading = true
        this.$store.dispatch('getPowerOfAttorney').finally(() => {
          this.loading = false
        })
      }
    },
    data () {
      return {
        loading: false
      }
    },
    methods: {
      revoke () {
        this.onRevokePoaFn()
      },
      uploadPoa (event) {
        const selectedFile = event.target.files[0]
        if (selectedFile) {
          this.loading = true
          this.$store.dispatch('uploadPowerOfAttorney', selectedFile).then(() => {
            this.showSuccessMsg({
              message: this.$t('message.accountPowerOfAttorneyForm.uploadSuccess')
            })
          }).catch(() => {
            this.showErrorMsg({
              message: this.$t('error.accountPowerOfAttorneyForm.uploadFailure')
            })
          }).finally(() => {
            this.loading = false
          })
        }
      }
    },
    props: {
      user: {
        type: Object,
        required: true
      },
      onPrintPoaFn: {
        type: Function,
        required: true
      },
      onRevokePoaFn: {
        type: Function,
        required: true
      }
    },
    notifications: {
      showSuccessMsg: {
        type: 'success'
      },
      showErrorMsg: {
        type: 'error'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/account/AccountPowerOfAttorneyForm.vue